/*
* Resideo/LifeWhere
* Copyright (C) 2018-2023 Resideo/LifeWhere
* mailto:nathan.williams@resideo.com
*/

import http from "../http-common";
import { Equipment } from "../componentObjects";

const controller = "/partners";

// RIS migration: a non-integer orgId is a RIS proCompanyId (base64 GUID).
// The onboarding/training endpoints only accept TT integer org IDs.
// Passing orgId=1 returns data for all partners, which is the desired fallback behavior.
const isProPartnerId = (partnerId) =>
    partnerId !== null && partnerId !== undefined && partnerId !== "" && isNaN(Number(partnerId));
class PartnerService {

    //set isActive = false for VersionCheck  
    async get(obj) { 
        const response = await http.post(`${controller}/getpartnerlist`, obj); 
        const data = await response.data;
        return data;
    }

    // POC: pro backend partner list — returns Datum[] mapped to { organizationId, name }
    async progetpartnerlist() {
        const response = await http.get(`${controller}/propartnerlist`);
        const data = await response.data;
        return data;
    }

    // Pro backend: get a single partner/company detail from RIS by proCompanyId
    async getpropartnerdetail(proCompanyId) {
        if (!proCompanyId || proCompanyId === 'undefined' || proCompanyId === 'null') {
            return { data: null };
        }
        const response = await http.get(`${controller}/propartnerdetail?proCompanyId=${encodeURIComponent(proCompanyId)}`);
        return response;
    }

    // Get the RIS user record for a given Auth0 user ID (user.sub).
    // Returns partner account associations and roles — called during the login flow.
    async getRisUserInfo(userId) {
        const response = await http.get(`${controller}/risuserinfo?userId=${encodeURIComponent(userId)}`);
        return response.data;
    }

    // Get customer and partner information from an asset ID.
    // Supports both RIS-based (tag lookup) and legacy TwinThread (org hierarchy) assets.
    async getAssetCustomerInfo(assetId) {
        const response = await http.get(`${controller}/assetcustomerinfo?assetId=${assetId}`);
        return response.data;
    }

    async getmainpartners(organization) {
        const response = await http.get(`${controller}/mainpartners?organization=${organization}`);
        const data = await response.data;
        return data;
    }
    async addnewpartner(partner) {
        const response = await http.post(`${controller}/addnewpartner`, partner);
        const data = await response.data;
        return data;
    }

    async refreshdashboardsection(section, currInfo) {
        const response = await http.post(`${controller}/refreshdashboardsection?section=${section}`, currInfo);
        const data = await response.data;
        return data;
    }

    async getallstateassets(requestObj) {
        const response = await http.post(`${controller}/getallstateassets`, requestObj);
        const data = await response.data;
        return data;
    }

    async getonboardingsummary(orgId) {
        const effectiveOrgId = isProPartnerId(orgId) ? 1 : orgId;
        const response = await http.get(`${controller}/getonboardingsummary?orgId=${effectiveOrgId}`);
        const data = await response.data;
        return data;
    }
    
    async getonboardinginfo(orgId, assetType = Equipment.AIR_CONDITIONER, isRetrain = false) {
        // RIS migration: backend only accepts TT integer org IDs; use orgId=1 (all partners) for RIS GUIDs
        const effectiveOrgId = isProPartnerId(orgId) ? 1 : orgId;
        const response = await http.get(`${controller}/getonboardinginfo?orgId=${effectiveOrgId}&assetType=${assetType}&isRetrain=${isRetrain}`);
        const data = await response.data;
        return data;
    }
    
    async gettrainingsessioninfo(session) {
        const response = await http.post(`${controller}/gettrainingsessioninfo`, session);
        const data = await response.data;
        return data;
    }

    async getassettraininginfo(orgId, assetType = Equipment.AIR_CONDITIONER, isRetrain = false) {
        const effectiveOrgId = isProPartnerId(orgId) ? 1 : orgId;
        const response = await http.get(`${controller}/getassettraininginfo?orgId=${effectiveOrgId}&assetType=${assetType}&isRetrain=${isRetrain}`);
        const data = await response.data;
        return data;
    }

    async updateservicetier(partnerId,tierId) {
        const response = await http.post(`${controller}/updateservicetier?partnerId=${partnerId}&tierId=${tierId}`);
        const data = await response.data;
        return data;
    }

    async updatemuteuntilalert(partnerId, muteUntilDate) {
        const response = await http.post(`${controller}/updatemuteuntilalert?partnerId=${partnerId}&muteUntilDate=${muteUntilDate}`);
        const data = await response.data;
        return data;
    }

    async adddeletedinfrastructure(partnerId, partnerCompanyName) {
        const response = await http.post(`${controller}/adddeletedinfrastructure?partnerId=${partnerId}&partnerCompanyName=${partnerCompanyName}`);
        const data = await response.data;
        return data;
    }

    async searchpartnerassets(partnerId,classId) {
        const response = await http.get(`${controller}/searchpartnerassets?partnerId=${partnerId}&classId=${classId}`);
        const data = response.data;
        return data;
    }

    async getpartnerproperties(partnerId, classId) {
        // Pro partners have base64 RIS IDs (non-integer) — look up the Organization
        // shadow twin by tag instead of by TT org hierarchy
        if (partnerId && isNaN(parseInt(partnerId))) {
            const response = await http.get(`${controller}/partnerpropertiesbypro?proCompanyId=${encodeURIComponent(partnerId)}`);
            const data = await response.data;
            return data;
        }
        const response = await http.get(`${controller}/partnerproperties?partnerId=${partnerId}`);
        const data = await response.data;
        return data;
    }

    async getinstallbyorgid(partnerId) {
        const response = await http.get(`${controller}/getinstallbyorgid?orgId=${partnerId}`);
        const data = response.data;
        return data;
    }
    
    async softdelete(organizationId){
        
        const response = await http.delete(`${controller}/softdelete/${organizationId}`);
        const data = await response.data;
        return data;
    }
    async resurrect(organizationId){

        const response = await http.post(`${controller}/resurrect/${organizationId}`);
        const data = await response.data;
        return data;
    }
    
    async softdelete(organizationId){
        
        const response = await http.delete(`${controller}/softdelete/${organizationId}`);
        const data = await response.data;
        return data;
    }
    async resurrect(organizationId){

        const response = await http.post(`${controller}/resurrect/${organizationId}`);
        const data = await response.data;
        return data;
    }
}

export default new PartnerService();
